<app-custom-switch-atom
  [items]="items"
  class="w-full mx-auto mb-3"
  [selectedValue]="selectedDistributionMode"
  [type]="'light'"
  (switchItem)="getSwitchValue($event)"
></app-custom-switch-atom>
